<div class="md-editor-container" [style.--editor-height]="height()">
  @if (formControl) {
    <md-editor
      [formControl]="formControl"
      [options]="editorOptions"
      (ngModelChange)="onContentChange($event)"
    />
  } @else {
    <md-editor
      [(ngModel)]="value"
      [options]="editorOptions"
      (ngModelChange)="onContentChange($event)"
    />
  }
</div>
